export const GET_TRAIL_BOOK_SUCCESS = 'GET_TRAIL_BOOK_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const ADD_VIDEO_TO_FAVORITE_LIST = 'ADD_VIDEO_TO_FAVORITE_LIST';
export const FILE_GENERATED_SUCCESS = 'FILE_GENERATED_SUCCESS';
export const SET_BULLET_STATUS = 'SET_BULLET_STATUS';
